import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { getBrokenLinksForDismissal } from '../utils/urls';

import { BrokenLinksType } from '../types/procedureBuilder';
import { ErrorModal } from 'types/modalTypes';

async function fetchBrokenLinksForDismissal({
  accountId,
  showPanel,
  payloadString,
}: TVariables): Promise<TResult> {
  if (!showPanel) {
    return new Promise((resolve, reject) => {
      reject();
    });
  }
  const response = await fetch(
    getBrokenLinksForDismissal(accountId, payloadString),
    {
      method: 'GET',
      headers: {
        Authorization: getTokenWithType(),
      },
    },
  );
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: Array<BrokenLinksType> | undefined;
  IsSuccess: boolean;
  StatusCode: number;
};

type TVariables = {
  accountId: number;
  showPanel: boolean;
  payloadString: string | undefined;
};

function useGetBrokenLinksForDismissal({
  accountId,
  showPanel,
  payloadString,
}: TVariables): UseQueryResult<TResult, TError> {
  return useQuery(
    ['getBrokenLinksForDismissal', accountId, showPanel, payloadString],
    async () => {
      return await fetchBrokenLinksForDismissal({
        accountId,
        showPanel,
        payloadString,
      });
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetBrokenLinksForDismissal };
